// Local
import Animate from './partials/animate';
import UploadControl from "./partials/upload-control";
import FieldsetRepeatable from "./partials/fieldset-repeatable";
import LanguagePicker from "./partials/language-picker";
import InfoAnimation from "./partials/info-animation";
import ModalMenu from "./partials/modal-menu";
import CtaListSwiper from "./partials/cta-list-swiper";
import ModalMenuList from "./partials/modal-menu-list";
import ProductCategoryList from "./partials/product-category-list";
import collapsable from "./partials/collapsable";
import ProductList from "./partials/product-list";
import GLightbox from "../../../../vendor/glightbox/glightbox.min";
import Tabs from "./partials/tabs";
import ProductCategorySwiper from "./partials/product-category-swiper";
import RealisationListSwiper from "./partials/realisation-list-swiper";
import AddToCart from "./partials/add-to-cart";
import Search from "./partials/search";
import SearchAll from "./partials/searchAll";
import ProductImagesSwiper from "./partials/product-images-swiper";
import MobileCategoryMenu from "./partials/mobile-category-menu";

window.initDom = ($wrapper) => {
    GLightbox({})

    $wrapper.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
    $wrapper.querySelectorAll('[data-upload]').forEach($el => new UploadControl($el));
    $wrapper.querySelectorAll('[data-form-repeatable]').forEach($el => new FieldsetRepeatable($el));
    $wrapper.querySelectorAll('[data-language-picker]').forEach($el => new LanguagePicker($el));
    $wrapper.querySelectorAll('[data-info-animation]').forEach($el => new InfoAnimation($el));
    $wrapper.querySelectorAll('[data-modal-menu]').forEach($el => new ModalMenu($el));
    $wrapper.querySelectorAll('[data-cta-swiper]').forEach($el => new CtaListSwiper($el));
    $wrapper.querySelectorAll('[data-modal-menu-list]').forEach($el => new ModalMenuList($el));
    $wrapper.querySelectorAll('[data-product-category-list]').forEach($el => new ProductCategoryList($el));
    $wrapper.querySelectorAll('[data-collapsable]').forEach($el => new collapsable($el));
    $wrapper.querySelectorAll('[data-tabs]').forEach($el => new Tabs($el));
    $wrapper.querySelectorAll('[data-product-category-swiper]').forEach($el => new ProductCategorySwiper($el));
    $wrapper.querySelectorAll('[data-block-type="block-product-list"]').forEach($el => (new ProductList($el)));
    $wrapper.querySelectorAll('[data-realisation-swiper]').forEach($el => (new RealisationListSwiper($el)));
    $wrapper.querySelectorAll('[data-search-wrapper]').forEach($el => (new Search($el)));
    $wrapper.querySelectorAll('[data-search-all-wrapper]').forEach($el => (new SearchAll($el)));
    $wrapper.querySelectorAll('[data-product-images-swiper]').forEach($el => (new ProductImagesSwiper($el)));
    $wrapper.querySelectorAll('[data-mobile-category-menu]').forEach($el => (new MobileCategoryMenu($el)));
    $wrapper.querySelectorAll('[data-form]').forEach(async ($el) => {
        const Form = await import('./partials/form');
        (new Form.default($el));
    });

    $wrapper.querySelectorAll('[data-add-to-cart]').forEach($el => (new AddToCart($el)))
}

(function() {
    window.initDom(document);
})();
